var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87097 5.96696C6.22177 5.47913 5.88306 4.85826 5.88306 4.21522V2.41913C6.05242 2.35261 6.19355 2.19739 6.19355 2.04217V1.4213C6.19355 1.19957 5.96774 1 5.65726 1H3.37097C3.08871 1 2.83468 1.17739 2.83468 1.4213V2.04217C2.83468 2.21957 3.00403 2.39696 3.20161 2.4413V4.1487C3.20161 4.83609 2.83468 5.47913 2.18548 5.92261C1.45161 6.43261 1 7.18652 1 7.98478V16.2778C1 16.6548 1.39516 16.9652 1.875 16.9652H7.125C7.60484 16.9652 8 16.6548 8 16.2778V7.98478C8 7.23087 7.60484 6.49913 6.87097 5.96696ZM5.62903 1.44348V1.99783H5.60081H3.5121H3.42742V1.44348H5.62903ZM7.43548 16.2556C7.43548 16.3887 7.29435 16.4996 7.125 16.4996H1.90323C1.73387 16.4996 1.59274 16.3887 1.59274 16.2556V7.98478C1.59274 7.31956 1.95968 6.69869 2.58065 6.25522C3.34274 5.72304 3.79435 4.94696 3.79435 4.1487V2.46348H5.31855V4.23739C5.31855 5.01348 5.74194 5.74522 6.50403 6.29956C7.09677 6.74304 7.43548 7.34174 7.43548 7.98478V16.2556Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemIcon);
export default __webpack_public_path__ + "static/media/item_icon.818ee0d1.svg";
export { ForwardRef as ReactComponent };